import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Input, DatePicker, Select, Checkbox } from 'antd';

import {
    selectorDadesBasiquesEditades,
    selectorMostrarErrors,
    selectorCodiEstacioNoInformat,
    selectorCodiEstacioSuperaMaximCaracters,
    selectorNomEstacioNoInformat,
    selectorDataAltaDataBaixaNoCoherents,
    selectorTipusEstacioNoInformat
} from '../../selectors/selector_estacio_formulari_dades';

import {
    selectorOpcionsTipusEstacio
} from '../../selectors/selector_estacio_formulari_estructura';

import {
    MASCARA_DDMMYYYY,
    MASCARA_YYYYMMDD,
    convertirTextAMomentUTC,
    esDataIniciPeriodeDeshabilitat
} from '../../commons/gestioDates';

import {
    estacioIntroduccioDadesBasiquesModificarNom,
    estacioIntroduccioDadesBasiquesModificarCodi,
    estacioIntroduccioDadesBasiquesModificarDataAlta,
    estacioIntroduccioDadesBasiquesModificarTipusEstacio,
    estacioIntroduccioDadesBasiquesModificarCodiAEMET,
    estacioIntroduccioDadesBasiquesModificarOperativa
} from '../../actions/estacio';

import PopoverError from '../commons/popoverError';
import { textQuanNoHiHaDada } from '../../constants';

const { Option } = Select;

const granuralitatComparativaDates = 'days';
const missatgeCampObligatori = 'Camp obligatori';
const missatgeControlDates = 'La data d\'alta no pot ser nul·la si la data de baixa està informada';
const missatgeCodiEstacioNoPotSuperarMaximCaracters = 'El codi de l\'estació no pot tenir més de 5 caràcters';

class EstacioIntroduccioDadesBasiques extends Component {

    constructor(props) {
        super(props);

        this.esDiaDeshabilitatDataAlta = this.esDiaDeshabilitatDataAlta.bind(this);
    }

    esDiaDeshabilitatDataAlta(dataCalendari, dataBaixa) {
        const dataActual = convertirTextAMomentUTC(this.props.dataActualText);
        return esDataIniciPeriodeDeshabilitat(dataCalendari, dataActual, dataBaixa, granuralitatComparativaDates);
    }

    renderitzarOpcionsSelectTipusEstacio() {
        return this.props.opcionsTipusEstacio.map(opcio => {
            return (
                <Option key={opcio.id} value={opcio.id} >
                    {opcio.codi}
                </Option>
            );
        });
    }

    generarIconaErrorCampObligatori(estaCampNoInformat) {
        if (estaCampNoInformat) {
            return <PopoverError contingut={missatgeCampObligatori} classNameIcona='icona-error' />;
        }
    }

    generarIconaErrorControlDates(dataAltaDataBaixaNoCoherents) {
        if (dataAltaDataBaixaNoCoherents) {
            return <PopoverError contingut={missatgeControlDates} classNameIcona='icona-error'/>;
        }
    }

    generarIconaErrorCampSuperMaximCaracters(campSuperaMaximCaracters) {
        if (campSuperaMaximCaracters) {
            return <PopoverError contingut={missatgeCodiEstacioNoPotSuperarMaximCaracters} classNameIcona='icona-error'/>;
        }
    }

    render() {

        const {
            dadesBasiques,
            mostrarErrors,
            codiEstacioNoInformat,
            nomEstacioNoInformat,
            dataAltaDataBaixaNoCoherents,
            codiEstacioSuperaMaximCaracters,
            idTipusEstacioNoInformat
        } = this.props;

        const { codi, nom, idTipusEstacio, codiAEMET, operativa } = dadesBasiques;

        const dataAltaText = dadesBasiques.dataAlta;
        const dataBaixaText = dadesBasiques.dataBaixa;

        const dataAlta = (dataAltaText) ? convertirTextAMomentUTC(dataAltaText, MASCARA_YYYYMMDD) : null;
        const dataBaixa = (dataBaixaText) ? convertirTextAMomentUTC(dataBaixaText, MASCARA_YYYYMMDD) : null;
        const dataBaixaAMostrar = dataBaixa ? dataBaixa.format(MASCARA_DDMMYYYY) : textQuanNoHiHaDada;

        let errorCodiEstacio;
        let errorNomEstacio;
        let errorDataAltaEstacio;
        let errorTipusEstacio;

        if (mostrarErrors) {
            errorCodiEstacio = this.generarIconaErrorCampObligatori(codiEstacioNoInformat) || this.generarIconaErrorCampSuperMaximCaracters(codiEstacioSuperaMaximCaracters);
            errorNomEstacio = this.generarIconaErrorCampObligatori(nomEstacioNoInformat);
            errorDataAltaEstacio = this.generarIconaErrorControlDates(dataAltaDataBaixaNoCoherents);
            errorTipusEstacio = this.generarIconaErrorCampObligatori(idTipusEstacioNoInformat);
        }

        const opcionsTipusEstacioRenderitzat = this.renderitzarOpcionsSelectTipusEstacio();

        return (
            <div className='estacio-introduccio-dades-basiques'>
                <div className='fila'>
                    <span className='titol'> Codi: </span>
                    <Input
                        className='input'
                        defaultValue={codi}
                        onBlur={(event) => {
                            const valor = event.target.value;
                            this.props.estacioIntroduccioDadesBasiquesModificarCodi(valor ? valor : null);
                        }}
                    />
                    {errorCodiEstacio}
                </div>
                <div className='fila'>
                    <span className='titol'> Nom: </span>
                    <Input
                        className='input'
                        defaultValue={nom}
                        onBlur={(event) => {
                            const valor = event.target.value;
                            this.props.estacioIntroduccioDadesBasiquesModificarNom(valor ? valor : null);
                        }}
                    />
                    {errorNomEstacio}
                </div>
                <div className='fila'>
                    <span className='titol'> Tipus: </span>
                    <Select
                        className='input'
                        value={idTipusEstacio}
                        allowClear
                        onChange={(opcioSeleccionada) => {
                            this.props.estacioIntroduccioDadesBasiquesModificarTipusEstacio(opcioSeleccionada ? opcioSeleccionada : null);
                        }}
                    >
                        {opcionsTipusEstacioRenderitzat}
                    </Select>
                    {errorTipusEstacio}
                </div>
                <div className='fila'>
                    <span className='titol'> Data d'alta: </span>
                    <DatePicker
                        className='input'
                        defaultValue={dataAlta}
                        format={MASCARA_DDMMYYYY}
                        onChange={(data) => this.props.estacioIntroduccioDadesBasiquesModificarDataAlta(data)}
                        disabledDate={(data) => this.esDiaDeshabilitatDataAlta(data, dataBaixa)}
                    />
                    {errorDataAltaEstacio}
                </div>
                <div className='fila estacio-databaixa'>
                    <span className='titol'> Data de baixa: </span>
                    {dataBaixaAMostrar}
                </div>
                <div className='fila estacio-introduccio-dades-basiques-codiAemet-operativa'>
                    <span className='titol'> Codi AEMET: </span>
                    <Input
                        className='input'
                        defaultValue={codiAEMET}
                        onBlur={(event) => {
                            const valor = event.target.value;
                            this.props.estacioIntroduccioDadesBasiquesModificarCodiAEMET(valor ? valor : null);
                        }}
                    />
                </div>
                <div className='fila'>
                    <span className='titol'> Operativa: </span>
                    <Checkbox
                        checked={operativa}
                        onChange={(event) => this.props.estacioIntroduccioDadesBasiquesModificarOperativa(event.target.checked)}
                    />
                </div>
            </div>
        );
    }
}

EstacioIntroduccioDadesBasiques.propTypes = {
    dadesBasiques: PropTypes.object,
    opcionsTipusEstacio: PropTypes.array,
    dataActualText: PropTypes.string,
    codiEstacioNoInformat: PropTypes.bool,
    codiEstacioSuperaMaximCaracters: PropTypes.bool,
    nomEstacioNoInformat: PropTypes.bool,
    dataAltaDataBaixaNoCoherents: PropTypes.bool,
    idTipusEstacioNoInformat: PropTypes.bool,
    mostrarErrors: PropTypes.bool,
    estacioIntroduccioDadesBasiquesModificarCodi: PropTypes.func,
    estacioIntroduccioDadesBasiquesModificarNom: PropTypes.func,
    estacioIntroduccioDadesBasiquesModificarDataAlta: PropTypes.func,
    estacioIntroduccioDadesBasiquesModificarTipusEstacio: PropTypes.func,
    estacioIntroduccioDadesBasiquesModificarCodiAEMET: PropTypes.func,
    estacioIntroduccioDadesBasiquesModificarOperativa: PropTypes.func
};

const mapStateToProps = (state) => {
    return {
        dadesBasiques: selectorDadesBasiquesEditades(state),
        opcionsTipusEstacio: selectorOpcionsTipusEstacio(state),
        mostrarErrors: selectorMostrarErrors(state),
        codiEstacioNoInformat: selectorCodiEstacioNoInformat(state),
        codiEstacioSuperaMaximCaracters: selectorCodiEstacioSuperaMaximCaracters(state),
        nomEstacioNoInformat: selectorNomEstacioNoInformat(state),
        dataAltaDataBaixaNoCoherents: selectorDataAltaDataBaixaNoCoherents(state),
        idTipusEstacioNoInformat: selectorTipusEstacioNoInformat(state)
    };
};

const mapDispatchToProps = {
    estacioIntroduccioDadesBasiquesModificarNom,
    estacioIntroduccioDadesBasiquesModificarCodi,
    estacioIntroduccioDadesBasiquesModificarDataAlta,
    estacioIntroduccioDadesBasiquesModificarTipusEstacio,
    estacioIntroduccioDadesBasiquesModificarCodiAEMET,
    estacioIntroduccioDadesBasiquesModificarOperativa
};

export default connect(mapStateToProps, mapDispatchToProps)(EstacioIntroduccioDadesBasiques);



// WEBPACK FOOTER //
// ./src/components/estacio/estacioIntroduccioDadesBasiques.js